import { render } from "./BuildTypes.vue?vue&type=template&id=3229494e&scoped=true"
import script from "./BuildTypes.vue?vue&type=script&lang=ts"
export * from "./BuildTypes.vue?vue&type=script&lang=ts"

import "./BuildTypes.vue?vue&type=style&index=0&id=3229494e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3229494e"

export default script